import { getFormattedOdds } from './utils/formatOdds';
import { createSelectionButton } from './utils/createSelectionButton';
import { createHeaderInfo } from './utils/createHeaderInfo';
import { doTrack } from '../analytics';
export const mapLambdaData = ({ card, oddsFormat, navigate, selectionsInBetslip, index, deepLinkUrl, }) => {
    const handleOnClick = async (event) => {
        event.preventDefault();
        await doTrack({ index: index + 1, title: card.selectionName });
        navigate(card.eventUrl, {});
    };
    return {
        concessionType: card.concessionType,
        eventName: card.eventName,
        selectionName: card.selectionName,
        blurb: card.blurb,
        headerInfoText: createHeaderInfo(card.headerInfoType, card.headerInfoText, card.eventDateTime),
        oldOddsInfo: Object.keys(card.wasPrice).length
            ? `Was ${getFormattedOdds(oddsFormat, card.wasPrice.numerator, card.wasPrice.denominator)}`
            : null,
        selectionButton: createSelectionButton({
            concessionName: card.concessionType,
            selectionId: card.selectionId,
            selectionName: card.selectionName,
            oddsFormat: oddsFormat,
            numerator: card.currentPrice.numerator,
            denominator: card.currentPrice.denominator,
            selectionsInBetslip: selectionsInBetslip,
            index: index,
            deepLinkUrl: deepLinkUrl,
        }),
        eventLink: {
            href: card.eventUrl,
            onClick: handleOnClick,
        },
    };
};
